import { EUnitOfMeasure } from '../shared/enum';
import { TInputSlope } from '../shared/iProject';
import { EUnitOfMeasureImperialLabel, EUnitOfMeasureLabel, EUnitOfMeasureMetricLabel } from './enum';

export const slopeWidth: TInputSlope = 'slopeWidth';
export const slopeLength: TInputSlope = 'slopeLength';
export const slopeAngle: TInputSlope = 'slopeAngle';
export const transverseSlopeAngle: TInputSlope = 'transverseSlopeAngle';
export const initialWaterTableDepth: TInputSlope = 'initialWaterTableDepth';
export const impermeableLayerDepth: TInputSlope = 'impermeableLayerDepth';

export const slopePD= {
    [slopeWidth]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.meter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.foot,
        },
    },
    [slopeLength]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.meter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.foot,
        },
    },
    [slopeAngle]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureLabel.deg,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureLabel.deg,
        },
    },
    [transverseSlopeAngle]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureLabel.deg,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureLabel.deg,
        },
    },
    [initialWaterTableDepth]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.meter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.foot,
        },
    },
    [impermeableLayerDepth]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.meter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.foot,
        },
    },
};
